import { Card, CardProps } from "@mui/material";
import React, { FC } from "react";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(
    createStyles({
        root: {
            padding: "0 8px !important",
        },
        container: {
            margin: "0 -8px !important",
            width: "unset",
        },
    }),
);

export const VCard: FC<CardProps> = (props) => {
    const { children, ...rest } = props;
    const classes = useStyles();
    return (
        <Card {...rest} className={classes.root}>
            {children}
        </Card>
    );
};
